import { CONFIG } from './config.js';

export class Powers {
  constructor() {
    this.magnetTime = 0;
    this.hoverboardTime = 0;
    this.hoverboardAvailable = false; // inventory: one auto-revive charge after pickup
    this.usedRevive = false;
  }

  reset() {
    this.magnetTime = 0;
    this.hoverboardTime = 0;
    this.hoverboardAvailable = false;
    this.usedRevive = false;
  }

  grantMagnet() {
    this.magnetTime = CONFIG.magnetDuration;
  }

  grantHoverboard() {
    // pickup arms one auto-revive (and briefly rides)
    this.hoverboardAvailable = true;
    this.hoverboardTime = CONFIG.hoverboardDuration;
  }

  get magnetActive() {
    return this.magnetTime > 0;
  }

  get boardActive() {
    return this.hoverboardTime > 0;
  }

  update(dt) {
    if (this.magnetTime > 0) this.magnetTime = Math.max(0, this.magnetTime - dt);
    if (this.hoverboardTime > 0) this.hoverboardTime = Math.max(0, this.hoverboardTime - dt);
  }

  /** Try auto-revive on hit. Returns true if revived. */
  tryRevive() {
    if (this.hoverboardAvailable && !this.usedRevive) {
      this.hoverboardAvailable = false;
      this.usedRevive = true;
      this.hoverboardTime = CONFIG.hoverboardDuration;
      return true;
    }
    // already riding board: absorb one hit
    if (this.hoverboardTime > 0) {
      this.hoverboardTime = 0;
      return true;
    }
    return false;
  }
}
